import React from 'react';
import $ from 'jquery';
import './settings.css';
import ReactRoundedImage from 'react-rounded-image';
import { Auth } from 'aws-amplify';
// import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import { UserContext } from '../../components/UserContext';
import { cx } from '@emotion/css';
import { button } from '../../styles/components/buttons.style';
import { select } from '../../styles/components/forms.style';
import Select from 'react-select';

class Settings extends React.Component {
  static contextType = UserContext;
  constructor() {
    super();
    this.scroll = this.scroll.bind(this);
    this.state = {
      status: 'Save details',
      jwt: '',
      user: {},
      profilepicset: [
        '../assets/girl1.jpg',
        '../assets/boy1.jpg',
        '../assets/girl2.jpg',
        '../assets/boy2.jpg',
        '../assets/girl3.jpg',
        '../assets/boy3.jpg',
        '../assets/girl4.jpg',
        '../assets/boy4.jpg',
        '../assets/girl5.jpg',
        '../assets/boy5.jpg',
        '../assets/girl6.jpg',
        '../assets/boy6.jpg',
        '../assets/girl7.jpg',
        '../assets/boy7.jpg',
        '../assets/girl8.jpg',
        '../assets/boy8.jpg',
        '../assets/girl9.jpg',
        '../assets/boy9.jpg',
        '../assets/girl10.jpg',
        '../assets/boy10.jpg',
      ],
      profilepic: '',
      level: 5,
    };

    this.getToken();
  }
  setLevel(level) {
    this.setState((state) => ({
      level: Number(level),
    }));
  }

  componentWillUnmount() {
    const { user } = this.context;

    // Reset the profilepic to the existing avatar from UserContext
    this.setState({
      profilepic: `../assets/${user.profilepic}.jpg`,
    });
  }

  // updateuserDetails = async (user, jwt) => {
  //   this.setState({ status: 'Saving....' });

  //   user['grade'] = this.state.level;
  //   user['profilepic'] = this.state.profilepic.substring(10).slice(0, -4);

  //   const requestOptions = {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json', Authorization: jwt },
  //     body: JSON.stringify(user),
  //   };

  //   const response = await fetch(
  //     `https://api.prod.quizwizard.net/quiz/updateuser`,
  //     requestOptions
  //   );
  //   const data = await response.json();

  //   this.setState((state) => ({
  //     status: 'Saved',
  //   }));
  //   //console.log(data)
  // };


  updateuserDetails = async (user, jwt) => {
    this.setState({ status: 'Saving....' });

    user['grade'] = this.state.level;
    user['profilepic'] = this.state.profilepic.substring(10).slice(0, -4);

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify(user),
    };

    try {
      const response = await fetch(
        `https://api.prod.quizwizard.net/quiz/updateuser`,
        requestOptions
      );
      const data = await response.json();
      //console.log("Response data : ", data);
      if (!response.ok) {
        throw new Error(data.error || 'Failed to update user details');
      }


      // Update the UserContext with the new user details after saving
      const { setUser } = this.context;
      setUser((prevUser) => ({
        ...prevUser,
        grade: this.state.level,
        profilepic: this.state.profilepic.substring(10).slice(0, -4),
      }));

      this.setState({ status: 'Saved' });
    } catch (error) {
      console.error('Error updating user details:', error);
      this.setState({ status: 'Save failed' });
    }
  };

  getuserDetails = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: username }),
    };

    const response = await fetch(
      `https://api.prod.quizwizard.net/quiz/getuser`,
      requestOptions
    );
    const data = await response.json();

    this.setState((state) => ({
      profilepic: '../assets/' + data['profilepic'] + '.jpg',
      level: data['grade'],
      user: data,
      jwt: jwt,
    }));

    //console.log(this.state.user)
  };

  getToken = async () => {
    const res = await Auth.currentSession();
    const accessToken = res.getAccessToken();
    const jwt = accessToken.getJwtToken();
    const payload = accessToken.decodePayload();

    const user = await Auth.currentAuthenticatedUser();

    if (accessToken.payload.username.includes("Google_")) {
      this.getuserDetails(user.attributes['email'], jwt);

    }
    else {
      this.getuserDetails(payload.username, jwt);

    }







    document.title = 'Settings';

  };

  // changeProfilePic(picname) {
  //   console.log(picname.item)
  //   this.setState((state) => ({
  //     profilepic: picname.item,
  //   }));
  // }

  changeProfilePic(picname) {
    //console.log(picname.item);
    this.setState((state) => ({
      profilepic: picname.item,
    }));

    // Update the UserContext with the new profile picture
    const { setUser } = this.context;
    setUser((prevUser) => ({
      ...prevUser,
      profilepic: picname.item.substring(10).slice(0, -4), // Extract the profile picture name
    }));
  }

  scroll(direction) {
    let far = ($('.image-container').width() / 2) * direction;
    let pos = $('.image-container').scrollLeft() + far;
    $('.image-container').animate({ scrollLeft: pos }, 1000);
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    const leveloptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    return (
      <UserContext.Provider value={this.state.user}>
        <div>
          <div className="center_avatar">
            <div className="wrapper">
              <div className="image1">
                {this.state.profilepic == '' ? (
                  <Lottie options={defaultOptions} height={400} width={400} />
                ) : (
                  ''
                )}
                {this.state.profilepic != '' ? (
                  < img src={this.state.profilepic} alt="Profile" />
                ) : (
                  'Img not found'
                )}
              </div>
              <p className="s-title">Choose your avatar</p>

              <div className="img-wrapper">
                <a className="prev" onClick={this.scroll.bind(null, -1)}>
                  &#10094;
                </a>
                <div className="image-container">
                  {this.state.profilepicset.map((item) => (
                    <div
                      className="image-item"
                      onClick={() => this.changeProfilePic({ item })}
                    >
                      <div className="image-wrapper">
                        <img className="image" src={item} alt="" />
                      </div>
                    </div>
                  ))}
                </div>
                <a className="next" onClick={this.scroll.bind(null, 1)}>
                  &#10095;
                </a>
              </div>
            </div>
            <div className="input-field">
              <p className="label-type text-left">Grade</p>
              <Select
                className={cx(select)}
                classNamePrefix="select"
                name="level"
                options={leveloptions.map((times) => ({
                  value: times,
                  label: times,
                }))}
                onChange={(e) => this.setLevel(e.value)}
                value={{ value: this.state.level, label: this.state.level }}
              />
            </div>
            <br />
            <button
              type="button"
              className={cx(button)}
              onClick={() =>
                this.updateuserDetails(this.state.user, this.state.jwt)
              }
            >
              {this.state.status}
            </button>
          </div>
        </div>
      </UserContext.Provider >
    );
  }
}

export default Settings;